(function () {
  var tiles = document.querySelectorAll('[data-pp-stock-aware]');
  if (!tiles.length) return;

  Array.prototype.forEach.call(tiles, function (tile) {
    fetch(tile.href, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) return '';
        return response.text();
      })
      .then(function (html) {
        if (!html) return;
        var page = new DOMParser().parseFromString(html, 'text/html');
        if (page.querySelector('#product-grid .grid__item')) {
          tile.removeAttribute('data-pp-stock-aware');
        }
      })
      .catch(function () {});
  });
})();
